import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AtomicIntClass;
function AtomicInt() {
  if (AtomicIntClass === VOID) {
    class $ {
      constructor(value) {
        this.value_1 = value;
      }
      load_1zbae_k$() {
        return this.value_1;
      }
      addAndFetch_fpau44_k$(delta) {
        this.value_1 = this.value_1 + delta | 0;
        return this.value_1;
      }
      toString() {
        return this.value_1.toString();
      }
    }
    initMetadataForClass($, 'AtomicInt');
    AtomicIntClass = $;
  }
  return AtomicIntClass;
}
//region block: exports
export {
  AtomicInt as AtomicIntuadhvz5dttw2,
};
//endregion

//# sourceMappingURL=Atomics.js.mjs.map
